<template>
  <div class="container">
    <!-- 订阅提醒邮件 -->
    <div class="card" v-permission="'subscription:setting:emailNotification'">
      <div style="font-size: 14px;color: #667085;">{{ $t('message.subscription.remindEmailTitle') }}</div>
      <div style="margin: 24px 0;font-size: 14px;color: #667085;">{{ $t('message.subscription.remindEmailDesc') }}</div>
      <el-switch v-model="subsRemindSwitchState" @change="changeSubsRemindSwitch"/>
    </div>
  </div>
</template>

<script>
import { updateEmailNotification, getEmailNotification } from '@/views/subscription/api/subscription';
export default {
  data() {
    return {
      subsRemindSwitchState: false,
    };
  },
  created() {
    this.queryEmailNotification();
  },
  methods: {
    async queryEmailNotification() {
      const res = await getEmailNotification();
      // 现在只会返回 null, true, false 三种值，null代表默认开启
      if (res === '1' || res === null) {
        this.subsRemindSwitchState = true;
      }
      if (res === '0') {
        this.subsRemindSwitchState = false;
      }
    },
    changeSubsRemindSwitch() {
      updateEmailNotification(this.subsRemindSwitchState ? '1' : '0');
    },
  },
};
</script>

<style lang="scss" scoped>

.container {
  padding-right: 30px;
}

.card {
  width: 100%;
  padding: 24px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #EFEFF4;
}
</style>
